import React, { memo } from 'react';
import { useReframe } from 'nike-re-framejs';

import i18n from '@i18n';
import LiveStreams from './LiveStreams';
import useLiveStreamDataLoad from '../useLiveStreamDataLoad';
import { EMPTY } from '@/common/dataState';
import IntersectionObserver from '@/ui/IntersectionObserver';
import PropTypes from 'prop-types';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import { fireGAEvent } from '@/analytics';
import { LIVE_STREAMS } from '@/routing/routes';
import { navigate } from '@/routing';
import PageModule from '@/common/components/page-module/PageModule';

function LiveStreamsModule({ visible }) {
    useLiveStreamDataLoad(visible);
    const derefSub = useReframe();
    const ids = derefSub(['sub::liveStreams.matches.sorted.ids']);
    const disabled = ids.size < 6;
    const state = derefSub(['sub::liveStreams.data-state']);
    if (state === EMPTY) {
        return null;
    }

    function handleShowMore() {
        fireGAEvent(CURRENT_PAGE, 'Zobrazit viac', 'Zive prenosy');
        navigate(LIVE_STREAMS);
    }
    function handleShowAll() {
        fireGAEvent(CURRENT_PAGE, 'Vsetky Zive prenosy', 'Zive prenosy');
        navigate(LIVE_STREAMS);
    }
    return (
        <>
            <div className="module-separator" />
            <PageModule
                title={i18n('homepage.liveStreams.header')}
                link={i18n('common.terms.all')}
                disabled={disabled}
                onClick={handleShowAll}
            >
                <LiveStreams state={state} limited />
                <button
                    className="module-show-more"
                    disabled={disabled}
                    onClick={handleShowMore}
                    data-atid="live-streams-goTo-list"
                >
                    {i18n('common.show.all')}
                </button>
            </PageModule>
        </>
    );
}

LiveStreamsModule.propTypes = {
    visible: PropTypes.bool
};

export const IOLiveStreamsModule = memo(function IOLiveStreamsModule() {
    return <IntersectionObserver>{visible => <LiveStreamsModule visible={visible} />}</IntersectionObserver>;
});
